exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".enneagrammyAbout {\n  position: relative;\n  background-color: #ffffff;\n  backdrop-filter: blur(5px);\n-webkit-backdrop-filter: blur(5px);\n  box-sizing: border-box;\n  border-radius: 10px;\n  margin: 10px;\n  width: calc(100% - 20px);\n  padding: 18px;\n  margin-bottom: 10px;\n  margin-top: 50px;\n}", ""]);

